import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './Routes/Routes';
import Header from './Components/Header';
import Footer from './Components/FooterSection';
import SeoManager from './seo/SeoManager';

const App: React.FC = () => {
  return (
    <Router>
      <SeoManager />
      <Header />
      <AppRoutes />
      <Footer />
    </Router>
  );
};

export default App;
